import type { ReactNode } from "react";
import { HotkeysProvider as ReactHotkeysProvider } from "react-hotkeys-hook";

type HotkeysProviderProps = {
  children: ReactNode;
};

export function HotkeysProvider({ children }: HotkeysProviderProps) {
  return (
    <ReactHotkeysProvider initiallyActiveScopes={["global"]}>
      {children}
    </ReactHotkeysProvider>
  );
}
